import { GetStaticPaths, GetStaticProps } from 'next';

import { queryCMS } from 'utils/cms/api';
import { aboutPageQuery } from 'utils/cms/gql';
import { ISR_TIMEOUT } from 'utils/config';
import { marketPageId, MarketPages } from 'utils/sharedStrapiQueries/market';

import AboutPage from '../about';

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const id = await marketPageId(MarketPages.aboutPage, locale);
  const cookieId = await marketPageId(MarketPages.cookieBar, locale);
  const footerId = await marketPageId(MarketPages.footer, locale);

  const globalIds = { cookieId, footerId };

  const {
    data: {
      sharedCopies,
      aboutPage: page,
      awards,
      redirectPopups,
      cookieBar,
      navbar,
      footer,
    },
  } = await queryCMS({
    query: aboutPageQuery({ id, locale, globalIds }),
  });

  if (!page || !sharedCopies) return { notFound: true };

  return {
    props: {
      initialCopy: {
        head: page?.seo || null,
        global: sharedCopies[0]?.global || null,
        globalSettings: sharedCopies[0] || null,
        redirectPopup: redirectPopups[0] || null,
        cookieBar: cookieBar || null,
        navbar,
        footer,
      },
      page,
      awards,
    },
    revalidate: ISR_TIMEOUT,
  };
};

const PillarLandingPage = props => {
  return <AboutPage {...props} />;
};

export default PillarLandingPage;
